import { CompareListStatusItem, WishlistCheckboxItem } from '@navi-toolbox/ui-components';

export const notificationTemplateFactory = {
  wishlist: WishlistCheckboxItem,
  compare: CompareListStatusItem,
};
